import { limitesDoMes, limitesEmMilissegundos } from '../tempo/limitesDoMes.js';
// Um estudo conta no mês quando está ativo nele e houve ao menos uma visita
// com resultado "estudo" para a mesma pessoa dentro do mês.
export function estudosDoMes(estudos, visitas, ano, mes) {
    // `fim` exclusivo: o mês do relatório é o calendário do publicador
    // (ADR-0003), e um estudo iniciado às 23h do dia 31 pertence ao mês que
    // termina, não ao seguinte em UTC.
    const { inicio, fim } = limitesEmMilissegundos(limitesDoMes(ano, mes));
    const pessoasComVisitaDeEstudo = new Set();
    for (const v of visitas) {
        if (v.deleted || v.resultado !== 'estudo' || v.pessoa_id === null)
            continue;
        const t = new Date(v.em).getTime();
        if (t >= inicio && t < fim)
            pessoasComVisitaDeEstudo.add(v.pessoa_id);
    }
    // A unidade do relatório é a pessoa, não a linha de Estudo. Uma pessoa
    // pode ter dois estudos ativos (por exemplo, duas publicações) e ainda
    // assim conta uma vez; por isso a deduplicação acontece por `pessoa_id`.
    const contadas = new Set();
    for (const e of estudos) {
        if (e.deleted)
            continue;
        const iniciou = new Date(e.iniciado_em).getTime();
        const encerrou = e.encerrado_em === null ? Infinity : new Date(e.encerrado_em).getTime();
        const ativoNoMes = iniciou < fim && encerrou >= inicio;
        if (ativoNoMes && pessoasComVisitaDeEstudo.has(e.pessoa_id))
            contadas.add(e.pessoa_id);
    }
    return contadas.size;
}
//# sourceMappingURL=estudos.js.map